import { initContract } from "@ts-rest/core"
import { CreatePartnerInputSchema, CreatePartnerOutputSchema } from "./partners.schemas"
import { ErrorResponseSchema } from "../../shared"

const c = initContract()

export const partnersRoutes = c.router(
  {
    createPartnerAccount: {
      method: 'POST',
      path: '/workflows/create-partner',
      body: CreatePartnerInputSchema,
      responses: {
        200: CreatePartnerOutputSchema,
        400: ErrorResponseSchema,
        500: ErrorResponseSchema,
      },
    },
  }
)
